export default {
  text: 'Estamos preparando tu mesa 🍽…',
};
